// @ts-nocheck
// ! 语言管理
const languageKey = 'lang'
export const getLang = () => localStorage.getItem(languageKey)
export const setLang = lang => localStorage.setItem(languageKey, lang)

// ! token管理
const tokenKey = 'flowToken'
export const getToken = () => sessionStorage.getItem(tokenKey)
export const setToken = token => sessionStorage.setItem(tokenKey, token)

// ! portal token管理
const portalTokenKey = 'portalToken'
export const getPortalToken = () => sessionStorage.getItem(portalTokenKey)
export const setPortalToken = token => sessionStorage.setItem(portalTokenKey, token)

// ! portal host 管理
const hostKey = 'portalHost'
export const getHost = () => localStorage.getItem(hostKey)
export const setHost = host => localStorage.setItem(hostKey, host)

// !判断是否为测试环境
export const isTest = location.host.indexOf('172.16.210.207') > -1;
export const isUAT =
  location.host.indexOf('172.16.210.208') > -1 ||
  location.host.indexOf(
    'bpm-mobile-uat.t360.com.hk'
  ) > -1;
export const getUrl = isTest
  ? 'http://fuson-cam.k8s-test.clps.com.cn'
  : isUAT
  ? 'https://portal-uat.t360.com.hk'
  : 'http://portal-mobile.t360.com.hk';
// export const getUrl = 'http://portal-mobile.t360.com.hk';



// WEBPACK FOOTER //
// ./src/lib/storage.js